import { TabStyles } from '@tableau/widgets';

import { cssClass } from '../../style';
import { UploadWorkbookStyles } from './UploadWorkbookStyles';

const cssPrefix = 'UploadWorkbookProgressDialog';
const progressBarHeight = '5px';
const borderRadius = '10px';

export namespace UploadWorkbookProgressDialogStyles {

  export const contentContainer = cssClass(cssPrefix, 'contentContainer', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    $nest: {
      '& aside': {
        flex: '1',
        minWidth: 0 // To contain text inside
      }
    }
  });

  export const title = cssClass(cssPrefix, 'title', {
    fontSize: TabStyles.Typography.Sizing.XLarge
  });

  export const filename = cssClass(cssPrefix, 'filename', {
    fontSize: '14px',
    color: 'rgba(0,0,0,0.6)',
    marginBottom: '30px',
    ...UploadWorkbookStyles.handleFlexOverflow
  });

  export const status = cssClass(cssPrefix, 'status', {
    color: TabStyles.Typography.Color.PrimaryMedium
  });

  export const progressContainer = cssClass(cssPrefix, 'progress-container', {
    width: '100%',
    height: progressBarHeight,
    backgroundColor: TabStyles.Colors.L4,
    borderRadius
  });

  export const progressBar = cssClass(cssPrefix, 'progress-bar', {
    height: progressBarHeight,
    backgroundColor: TabStyles.Colors.ApplicationBlue,
    transition: 'width 0.25s ease-out',
    borderRadius
  });
}
